<!-- TEACHER-CERTIFICATION -->
<div *ngIf="enableTeacherCertificationSection" class="d-flex flex-row gap-3 align-items-center">
  <div class="user-img-spacer"></div>
  <div class="flex-grow-1 d-flex flex-column gap-3 ps-3">
    <!-- Btn -->
    <div class="d-flex align-items-center justify-content-between gap-3">
      <div class="fw-semibold opacity-50">Abilitazione:</div>
      <button
        *ngIf="(sectionsState$ | async)?.agreementsSection === true && !teacherCertificationLoading && !teacherCertification"
        mat-stroked-button color="primary" (click)="showTeacherCertificationDialog()" style="min-width: 198px;">
        Registra Abilitazione
      </button>
    </div>
    <!-- Loading -->
    <div *ngIf="teacherCertificationLoading" style="height: 96px;"
      class="d-flex justify-content-center align-items-center">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
    <!-- Error -->
    <div *ngIf="!teacherCertificationLoading && teacherCertificationError"
      class="d-flex justify-content-center align-items-center">
      <div>{{teacherCertificationError.message}}</div>
    </div>
    <!-- Teacher Certification -->
    <div *ngIf="teacherCertification" class="border dea-radius p-3">
      <div class="d-flex flex-row gap-3">
        <div class="d-flex flex-column gap-3 flex-grow-1 pt-2">
          <div class="d-flex flex-row gap-3">
            <div class="col m-0 p-0">
              <strong class="opacity-50 me-2">Anno:</strong>
              <span>{{teacherCertification.year}}</span>
            </div>
            <div class="col m-0 p-0 fs-065rr">
              <span class="opacity-50 me-2">Allegato:</span>
              <span>{{teacherCertification.attachment?'Sì':'No'}}</span>
              <span *ngIf="teacherCertification.attachment !== undefined" class="ms-3 text-decoration-underline pointer"
                (click)="downloadTeacherCertificationAttachment()">
                Scarica
              </span>
              <span *ngIf="teacherCertification.attachment !== undefined" class="ms-2 text-decoration-underline pointer"
                (click)="deleteTeacherCertificationAttachment()">
                Elimina
              </span>
            </div>
          </div>
          <div *ngIf="teacherCertificationSubjects !== undefined">
            <span class="opacity-50 me-2">Classi di concorso:</span>
            {{teacherCertificationSubjects}}
          </div>
          <div *ngIf="teacherCertification.description">
            <span class="opacity-50 me-2">Descrizione:</span>{{teacherCertification.description}}
          </div>
        </div>
        <div class="d-flex flex-column justify-content-between">
          <div class="d-flex flex-row justify-content-end gap-2">
            <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Modifica abilitazione"
              title="Modifica abilitazione" (click)="showTeacherCertificationDialog(teacherCertification.id)">
              <mat-icon class="mb-1">edit</mat-icon>
            </button>
            <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Elimina abilitazione"
              title="Elimina abilitazione" (click)="showTeacherCertificationDeleteDialog()">
              <i class="bi bi-trash3 dea-icon-btn text-danger" style="opacity: 1;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- TEACHER-CERTIFICATION -->
<!-- DIVIDER -->
<div *ngIf="enableTeacherCertificationSection" class="d-flex flex-row gap-3 align-items-center">
  <div class="user-img-spacer"></div>
  <hr class="ms-3 flex-grow-1 w-full" style="opacity: 0.1;">
</div>
<!-- DIVIDER -->
<!-- PHOTO-RELEASE-FORM -->
<div *ngIf="enableTeacherCertificationSection" class="d-flex flex-row gap-3 align-items-center">
  <div class="user-img-spacer"></div>
  <div class="flex-grow-1 d-flex flex-column gap-3 ps-3">
    <!-- Btn -->
    <div class="d-flex align-items-center justify-content-between gap-3">
      <div class="fw-semibold opacity-50">Liberatoria:</div>
      <button
        *ngIf="(sectionsState$ | async)?.agreementsSection === true && !teacherPhotoReleaseLoading && teacherPhotoRelease.length == 0"
        mat-stroked-button color="primary" (click)="showTeacherPhotoReleaseFormDialog()" style="min-width: 198px;">
        Registra Liberatoria
      </button>
    </div>
    <!-- Loading -->
    <div *ngIf="teacherPhotoReleaseLoading" style="height: 96px;"
      class="d-flex justify-content-center align-items-center">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
    <!-- Error -->
    <div *ngIf="!teacherPhotoReleaseLoading && teacherPhotoReleaseError"
      class="d-flex justify-content-center align-items-center">
      <div>{{teacherPhotoReleaseError.message}}</div>
    </div>
    <!-- Teacher Certification -->
    <div *ngFor="let document of this.teacherPhotoRelease;" class="border dea-radius p-3">
      <div class="d-flex flex-row gap-3">
        <div class="col m-0 p-0 my-auto">
          <strong class="opacity-50 me-2">Privacy:</strong>
          <mat-checkbox *ngIf="document?.type === 'PHOTO-RELEASE-FORM'" color="primary" [labelPosition]="'before'"
            [checked]="document?.checkbox" (change)="this.onChangeCheckbox($event, document)">
          </mat-checkbox>
          <span>{{document?.checkbox ? 'Sì' : 'No'}}</span>
        </div>
        <div class="col m-0 p-0 fs-065rr my-auto">
          <span class="opacity-50 me-2">Documento:</span>
          <span class="ms-3 text-decoration-underline pointer" aria-label="Scarica liberatoria"
            title="Scarica liberatoria" (click)="this.downloadTeacherPhotoReleaseFormAttachment(document)">
            Scarica
          </span>
        </div>
        <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Elimina liberatoria"
          title="Elimina liberatoria" (click)="this.showTeacherPhotoReleaseDeleteDialog(document)">
          <i class="bi bi-trash3 dea-icon-btn text-danger" style="opacity: 1;"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- PHOTO-RELEASE-FORM -->
<!-- DIVIDER -->
<div *ngIf="enableTeacherCertificationSection" class="d-flex flex-row gap-3 align-items-center">
  <div class="user-img-spacer"></div>
  <hr class="ms-3 flex-grow-1 w-full" style="opacity: 0.1;">
</div>
<!-- DIVIDER -->
<!-- AGREEMENTS -->
<div class="d-flex flex-row gap-3 align-items-center">
  <div class="user-img-spacer"></div>
  <div class="flex-grow-1 d-flex flex-column gap-3 ps-3">
    <!-- Btn -->
    <div class="d-flex align-items-center justify-content-between gap-3">
      <div class="fw-semibold opacity-50">Contratti:</div>
      <button *ngIf="(sectionsState$ | async)?.agreementsSection === true && !agreementsLoading" mat-stroked-button
        color="primary" (click)="showAgreementDialog()" style="min-width: 198px;">
        Registra Contratto
      </button>
    </div>
    <!-- Loading -->
    <div *ngIf="agreementsLoading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
    <!-- Error -->
    <div *ngIf="!agreementsLoading && agreementsError" class="d-flex justify-content-center align-items-center">
      <div>{{agreementsError.message}}</div>
    </div>
    <!-- Listing -->
    <ng-container *ngFor="let agreement of agreementsListing;">
      <div class="border dea-radius p-3">
        <div class="d-flex flex-row gap-3">
          <div class="d-flex flex-column gap-3 flex-grow-1 pt-2">
            <div class="d-flex flex-row gap-3">
              <div class="col m-0 p-0">
                <span class="opacity-50 me-2">Registrato il:</span>
                <span>{{agreement.createdAt ? (agreement.createdAt | date:'yyyy-MM-dd') : ' -'}}</span>
              </div>
            </div>
            <div class="row m-0 p-0">
              <div class="col m-0 p-0">
                <span class="opacity-50 me-2">Tipologia:</span>
                <span class="fw-bold text-capitalize">{{agreement.type?.toLowerCase()}}</span>
              </div>
              <div class="col m-0 p-0">
                <div class="col m-0 p-0"><span class="opacity-50 me-2">Ore:</span>{{agreement.hours || 0}} h</div>
              </div>
              <div class="col m-0 p-0 fs-065rr">
                <span class="opacity-50 me-2">Allegato:</span>
                <span>{{agreement.attachment?'Sì':'No'}}</span>
                <span *ngIf="agreement.attachment !== undefined" (click)="downloadAgreementAttachment(agreement)"
                  class="ms-3 text-decoration-underline pointer">
                  Scarica
                </span>
                <span *ngIf="agreement.attachment !== undefined" (click)="deleteAgreementAttachment(agreement)"
                  class="ms-2 text-decoration-underline pointer">
                  Elimina
                </span>
              </div>
            </div>
            <div class="row m-0 p-0">
              <div class="col m-0 p-0"><span class="opacity-50 me-2">RAL:</span>
                {{agreement.ral | currency:'EUR':'symbol':'1.2-2'}}
              </div>
              <div class="col m-0 p-0">
                <span class="opacity-50 me-2">Lordo Mensile:</span>
                {{agreement.monthly_gross | currency:'EUR':'symbol':'1.2-2'}}
              </div>
              <div class="col m-0 p-0">
                <span class="opacity-50 me-2">Netto Mensile:</span>
                {{agreement.monthly_net | currency:'EUR':'symbol':'1.2-2'}}
              </div>
            </div>
            <div *ngIf="agreement.code">
              <span class="opacity-50 me-2">Codice Contratto:</span>{{agreement.code}}
            </div>
            <div *ngIf="agreement.description">
              <span class="opacity-50 me-2">Descrizione:</span>{{agreement.description}}
            </div>
          </div>
          <div class="d-flex flex-column justify-content-between">
            <div class="d-flex flex-row justify-content-end gap-2">
              <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Modifica contratto"
                title="Modifica contratto" (click)="showAgreementDialog(agreement.id)">
                <mat-icon class="mb-1">edit</mat-icon>
              </button>
              <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Elimina contratto"
                title="Elimina contratto" (click)="showAgreementDeleteDialog(agreement.id)">
                <i class="bi bi-trash3 dea-icon-btn text-danger" style="opacity: 1;"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- AGREEMENTS -->